<template>
    <index-table
        :cols="[
            {
                value: 'name',
                label: 'Name',
                searchable: true,
                sortable: true,
            },
            {
                value: 'permissions',
                label: 'Permissions',
                display: 'name',
                searchable: false,
                sortable: false,
            },
        ]"
        :title="'Roles'"
        :model="'roles'"
        :createText="'Create Role'"
        :options="['editable', 'deletable']"
        data-test-id="roles-table"
    />
</template>

<script>
import IndexTable from '@/components/IndexTable/index.vue'

export default {
    components: {
        IndexTable,
    },
}
</script>
